"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.axiosInstance = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@mui/material/styles");

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));

var _core = require("@material-ui/core/");

var _axios = _interopRequireDefault(require("axios"));

var Interceptors = _interopRequireWildcard(require("./axios/interceptors"));

var _reactRouterDom = require("react-router-dom");

require("./styles/index.css");

var _appBarStyles = require("./styles/app-bar-styles");

var _logo = _interopRequireDefault(require("./logo.png"));

var _reactRedux = require("react-redux");

var _actions = require("./redux/actions");

var _store = _interopRequireDefault(require("./redux/store"));

var _myHistory = require("./myHistory");

var _HelpGuideViewer = _interopRequireDefault(require("./components/HelpGuideViewer"));

var _FromRedirect = _interopRequireDefault(require("./components/FromRedirect"));

var _LoginButton = require("./components/LoginButton");

var _UtilityIcons = _interopRequireDefault(require("./components/UtilityIcons"));

var _CookieConsent = _interopRequireDefault(require("./components/CookieConsent"));

var _oauth = require("./oauth");

var _utilities = require("./utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LOGOUT_URL = process.env.REACT_APP_TOKEN_LOGOUT;
var IS_DEV = process.env.REACT_APP_IS_JNPDEV ? Boolean(process.env.REACT_APP_IS_JNPDEV) : false;
var THEME = (0, _styles.createTheme)({
  typography: {
    "fontFamily": "\"Roboto:300,400,500,700\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif"
  }
});

function goToLocation(url) {
  window.location.assign(url);
}

var axiosInstance = _axios.default.create();

exports.axiosInstance = axiosInstance;
axiosInstance.interceptors.request.use(Interceptors.requestConfig, Interceptors.requestError);

if (!IS_DEV) {
  axiosInstance.interceptors.response.use(Interceptors.response, Interceptors.responseError);
}

function JNPWebServiceAppBar(props) {
  var classes = (0, _appBarStyles.useStyles)();
  var userInfo = props.userInfo,
      token = props.token,
      receiveToken = props.receiveToken,
      selectedTabIndex = props.selectedTabIndex,
      setSelectedTab = props.setSelectedTab,
      tabs = props.tabs,
      drawerOpen = props.drawerOpen,
      setDrawerOpen = props.setDrawerOpen,
      showUtilityBar = props.showUtilityBar,
      _props$backGroundColo = props.backGroundColor,
      backGroundColor = _props$backGroundColo === void 0 ? " #003061" : _props$backGroundColo;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openHelpGuide = _useState2[0],
      setOpenHelpGuide = _useState2[1]; //authentication functions


  function handleSuccess(responseData) {
    var token = responseData.access_token;
    receiveToken(token);

    _myHistory.myHistory.push("/");

    window.location.reload();
  }

  ;

  function handleError(error) {
    console.log(error);
    localStorage.setItem('TOKEN', null);
    goToLocation(process.env.REACT_APP_TOKEN_LOGOUT);
  }

  ; //appBar functions

  var handleLogout = function handleLogout() {
    localStorage.setItem('TOKEN', null);
    window.location.href = LOGOUT_URL;
  };

  var handleDrawer = function handleDrawer() {
    setDrawerOpen(!drawerOpen);
  }; //on mount


  (0, _react.useEffect)(function () {
    if (userInfo.username.length) {
      (0, _utilities.writeAccessLog)();
    }
  }, [userInfo]);
  var availableLinksEntries = Object.entries(userInfo.availableLinks);
  var helpGuidePath = (0, _utilities.resolveHelpGuidePath)(userInfo);
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: THEME
  }, /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: _store.default
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, {
    history: _myHistory.myHistory
  }, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "fixed",
    className: classes.appBar,
    style: {
      backgroundColor: backGroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, null, /*#__PURE__*/_react.default.createElement("img", {
    src: _logo.default,
    className: classes.brandLogo,
    alt: "JNPSOFT Logo"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fullBar
  }, availableLinksEntries.map(function (item, key) {
    var url = (0, _utilities.buildFromRedirectLink)(item[1], token);
    var underlined = (0, _utilities.isBaseUrlMatchService)(item[1]) ? 'always' : 'hover';
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "inherit",
      key: key
    }, /*#__PURE__*/_react.default.createElement(_core.Link, {
      className: classes.links,
      href: url,
      color: "inherit",
      underline: underlined
    }, item[0]));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.flexGrow
  }), /*#__PURE__*/_react.default.createElement(_LoginButton.LoginButton, {
    token: token,
    userInfo: userInfo,
    handleLogout: handleLogout
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.smallBar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.flexGrow
  }), /*#__PURE__*/_react.default.createElement(_LoginButton.LoginButtonSmall, {
    token: token,
    userInfo: userInfo,
    handleLogout: handleLogout,
    availableLinksEntries: availableLinksEntries
  }))), token && showUtilityBar && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    "aria-label": "sections",
    className: classes.tabs,
    value: selectedTabIndex,
    onChange: function onChange(event, value) {
      return setSelectedTab(value);
    },
    indicatorColor: "primary"
  }, tabs.map(function (item, key) {
    return /*#__PURE__*/_react.default.createElement(_Tab.default, {
      key: key,
      value: item.value,
      label: item.label
    });
  })), /*#__PURE__*/_react.default.createElement(_UtilityIcons.default, {
    helpGuidePath: helpGuidePath,
    handleDrawer: handleDrawer,
    setOpenHelpGuide: setOpenHelpGuide
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "oauth2"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/callback"
  }, /*#__PURE__*/_react.default.createElement(_oauth.MyOauthReceiver, {
    handleError: handleError,
    handleSuccess: handleSuccess
  })), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/login"
  }, /*#__PURE__*/_react.default.createElement(_oauth.MyOauthSender, {
    render: function render(_ref) {
      var url = _ref.url;
      return goToLocation(url);
    }
  })), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/from-redirect"
  }, /*#__PURE__*/_react.default.createElement(_FromRedirect.default, null)))), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    open: openHelpGuide,
    onClose: function onClose() {
      return setOpenHelpGuide(false);
    },
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_HelpGuideViewer.default, {
    pdfFile: helpGuidePath,
    handleClose: function handleClose() {
      return setOpenHelpGuide(false);
    }
  })), /*#__PURE__*/_react.default.createElement(_CookieConsent.default, null))));
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    token: state.loginReducer.token === 'null' || state.loginReducer.token === 'undefined' ? undefined : state.loginReducer.token,
    selectedTabIndex: state.appBarTabs.selectedTabIndex,
    drawerOpen: state.appBarTabs.drawerOpen,
    tabs: state.appBarTabs.tabs
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  receiveToken: _actions.receiveToken,
  setSelectedTab: _actions.setSelectedTab,
  setDrawerOpen: _actions.setDrawerOpen
})(JNPWebServiceAppBar);

exports.default = _default;